import '../assets/css/contacto.css';
import { FaWhatsapp, FaInstagram, FaFacebookF } from "react-icons/fa";


function Contacto(){
    return(
        <>
            <section className="contacto">
                
                <div className='contacto__cabezera'>
                    <h1>Contacto</h1>
                    <p>Contáctenos, nuestra amplia experiencia en el sector de las tapicerías nos avala. </p>
                    
                </div>
                
                <section className="contacto__container">
                    <div className="contacto__info">
                        <h2>Dirección:</h2>
                        <p>Tomás Nother 3431, José Mármol, Buenos Aires</p>
                        <h2>Teléfono:</h2>
                        <p>(011)1541872661</p>
                        <h2>Horario de atención:</h2>
                        <p>Lunes a viernes: de 08:00hs a 17:00hs</p>
                        <p>Sabados: 08:00hs a 13:00hs</p>
                    </div>
                   
                    <div className="contacto__contactanos">
                        <h2>Contactanos por Whatsapp</h2>
                        <p>Envianos una foto del producto vía Whatsapp.<br/> Es la forma más ágil para presupuestar el trabajo a realizar.</p>
                        <div style={{display:"flex", justifyContent:"flex-start"}}>
                            <a href='https://wa.me/111541872661' target='__bñanck'><FaWhatsapp  color='var(--green)' size={50}/></a>
                            <p ><a style={{textDecoration:"none",fontSize:"20px", color:"var(--dark)"}} href="https://wa.me/111541872661" target="__blank">+54911 4187-2661</a></p>
                        </div>
                        <h2>Comunicate a travez de nuestras redes</h2>
                        <p>solicitá tu presupuesto de manera rápida y segura</p>
                        <div className="contacto__redes">
                            <a href='https://www.facebook.com/profile.php?id=100085047979424&mibextid=2JQ9oc' target='__blank'><FaFacebookF  className='icono' size={40}/></a>
                            <a href='https://www.instagram.com/myztapizados/' target='__blank'><FaInstagram  className='icono' size={40}/></a>
                        </div>
                        
                    </div>
                </section>
                <div className="contacto__mapa">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3276.867997315683!2d-58.364184624089674!3d-34.78409826704721!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95a32d802f99a35d%3A0x221e77f722d2eb0c!2sMyZ%20tapizados!5e0!3m2!1ses-419!2sar!4v1698628433265!5m2!1ses-419!2sar" width="100%" height="300px"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </section>
        </>
    )
}

export default Contacto;